export interface PlatformDefinition {
  value: string;
  label: string;
  runType: string;
  description: string;
  color: string;
}

export const BAD_CASE_PLATFORMS: readonly PlatformDefinition[] = [
  {
    value: "yumemi",
    label: "Yumemi",
    runType: "yumemi_tts",
    description: "Yumemi 公网声线 / API 回归",
    color: "#8b5cf6",
  },
  {
    value: "vuilabs",
    label: "VUILabs",
    runType: "vuilabs_tts",
    description: "VUILabs 公网声线 / API 回归",
    color: "#1769ff",
  },
  {
    value: "v63_reference_test_run",
    label: "V63 Reference",
    runType: "reference_boundary",
    description: "Reference、文本和语速边界批测",
    color: "#0ea5a4",
  },
] as const;

export const UNKNOWN_PLATFORM = "unknown";

export const normalizePlatform = (value?: string | null) => value?.trim() || UNKNOWN_PLATFORM;

export function platformDefinition(value?: string | null, runType?: string | null): PlatformDefinition {
  const normalized = normalizePlatform(value);
  const known = BAD_CASE_PLATFORMS.find((item) => item.value === normalized || item.runType === runType);
  if (known) return known;
  return {
    value: normalized,
    label: normalized === UNKNOWN_PLATFORM ? "未标注平台" : normalized,
    runType: runType?.trim() || "unknown",
    description: normalized === UNKNOWN_PLATFORM ? "历史记录需要补充平台快照" : "历史或扩展测试平台",
    color: "#667085",
  };
}
